export interface IBaseEnvironment {
  enableAngularProdMode: boolean;
  accessManagerUrl: string;
  baseDomain: string;
  backEndUrl: string;
  successBackOfficeUrl: string;
  environmentName?: string;
}
